import React from "react";
import { IconButton } from "@mui/material";

export type SidebarIconButtonProps = {
  icon: React.ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  opacity?: number;
  /**
   * 메뉴/팝업 트리거로 사용될 때 펼침 상태를 보조 기술에 알린다.
   */
  ariaExpanded?: boolean;
  /**
   * 클릭 시 노출되는 팝업 종류 (menu, listbox, dialog 등).
   */
  ariaHasPopup?: React.AriaAttributes["aria-haspopup"];
  /**
   * 트리거가 제어하는 팝업 요소의 id. 펼쳐졌을 때만 부여한다.
   */
  ariaControls?: string;
};

export function SidebarIconButton({
  icon,
  onClick,
  disabled = false,
  opacity = 1,
  ariaExpanded,
  ariaHasPopup,
  ariaControls,
}: SidebarIconButtonProps) {
  return (
    <IconButton
      disabled={disabled}
      onClick={onClick}
      aria-expanded={ariaExpanded}
      aria-haspopup={ariaHasPopup}
      aria-controls={ariaControls}
      sx={{
        width: 40,
        height: 40,
        opacity,
        "&:hover": {
          backgroundColor: "rgba(0, 0, 0, 0.04)",
        },
        "&:disabled": {
          opacity: 0.3,
        },
      }}
    >
      {icon}
    </IconButton>
  );
}
